import styles from './ConfiguratorSummary.module.scss';
import Button from '../../../ui/Button/Button';
import React from 'react';
import Chevron from '../../../Icons/Chevron';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { formatCurrency } from '../utils';

export default function Summary({
  step,
  index,
  selectedCategoryCar,
  steps,
  onClickStep,
  sitecoreData,
}) {
  const carTypeItemSelected = steps
    ?.find((item) => item.stepValue === 1)
    ?.items?.find((item) => item.selected);
  console.log(carTypeItemSelected, '*****9999999999');

  const carVersionItemSelected = steps
    .find((item) => item.stepValue === 2)
    ?.items?.find((item) => item.selected);

  const carColor = steps
    .find((item) => item.stepValue === 3)
    ?.carTypes?.[selectedCategoryCar]?.items.find((item) => item.selected);
  const colorPrice = carColor ? carColor?.price || 0 : 0;

  const carInterior = steps
    .find((item) => item.stepValue === 4)
    ?.carTypes?.[selectedCategoryCar]?.items.find((item) => item.selected)
    ?.interiors?.find((item) => item.selected);
  const interiorPrice = carInterior ? carInterior?.price || 0 : 0;

  const firstCarLuxuryPrice = carVersionItemSelected?.price || 0;

  const resultCarPrice =
    interiorPrice + colorPrice + firstCarLuxuryPrice + carTypeItemSelected?.price;

  // 获取车型参数，用于 Enquire 按钮的 URL
  const getCarModelParam = () => {
    if (!carTypeItemSelected) return '';

    // 从 Sitecore 数据中获取 EnquireCarModel，如果没有则使用 title
    const enquireCarModel = carTypeItemSelected.EnquireCarModel;
    const carModelTitle = carTypeItemSelected.title;

    return enquireCarModel || carModelTitle || '';
  };

  const handleGoToCalculator = () => {
    // 优先使用 finalCarUrl 字段
    const finalCarUrl = carTypeItemSelected?.finalCarUrl?.href;
    const href = `${finalCarUrl || ''}?carModel=${encodeURIComponent(
      getCarModelParam()
    )}&carColor=${encodeURIComponent(carColor?.colorName || '')}&carVersion=${encodeURIComponent(
      carVersionItemSelected?.title || ''
    )}${carTypeItemSelected?.finalCarUrl?.querystring || ''}`;

    if (finalCarUrl) {
      // 如果有 finalCarUrl，直接跳转到该URL
      window.location.href = href;
    } else {
      // // 保留原有功能：跳转到finance-calculator页面
      // const params = new URLSearchParams({
      //   from: 'car-configurator',
      //   carType: carTypeItemSelected?.title || '',
      //   carVersion: carVersionItemSelected?.title || '',
      //   carColor: carColor?.colorName || '',
      //   carPrice: resultCarPrice.toString(),
      // });
      // // 跳转到finance-calculator页面，使用Sitecore配置的URL
      // const financeCalculatorUrl = step?.financeCalculatorUrl?.href || '/finance-calculator';
      // window.location.href = `${financeCalculatorUrl}?${params.toString()}`;
    }
  };

  const getItemValue = (item) => {
    // 如果 Sitecore 直接配置了 value，直接使用
    if (item.value) {
      return item.value;
    }

    // 如果 Sitecore 配置了 valueSource，根据 source 获取对应的值
    if (item.valueSource) {
      switch (item.valueSource) {
        case 'carType':
          return carTypeItemSelected?.title;
        case 'version':
          return carVersionItemSelected?.title;
        case 'colour':
          return carColor?.colorName;
        case 'interior':
          return carInterior?.interiorName;
        case 'estimatedPrice':
          return formatCurrency(resultCarPrice, step?.priceUnit);
        default:
          return '';
      }
    }

    // 使用 oneCategory, twoCategory, threeCategory 来匹配
    const category = item.category;
    if (category && sitecoreData) {
      const { oneCategory, twoCategory, threeCategory, fourCategory } = sitecoreData;

      // 匹配第一步的 category
      if (category === oneCategory?.value) {
        return carTypeItemSelected?.title;
      }

      // 匹配第二步的 category
      if (category === twoCategory?.value) {
        return carVersionItemSelected?.title;
      }

      // 匹配第三步的 category
      if (category === threeCategory?.value) {
        return carColor?.colorName;
      }

      // 匹配第四步的 category
      if (category === fourCategory?.value) {
        return carInterior?.interiorName;
      }

      // 特殊处理价格
      if (category === 'estimatedPrice' || category === 'price') {
        return formatCurrency(resultCarPrice, step?.priceUnit);
      }
    }

    // 向后兼容：如果没有配置 value 或 valueSource，尝试使用硬编码的 category
    if (category) {
      switch (category) {
        case 'carType':
        case 'car_type':
        case 'car-type':
        case 'autotype':
          return carTypeItemSelected?.title;
        case 'version':
        case 'versie':
          return carVersionItemSelected?.title;
        case 'colour':
        case 'color':
        case 'kleur':
          return carColor?.colorName;
        case 'interior':
          return carInterior?.interiorName;
        case 'estimatedPrice':
        case 'price':
        case 'geschatte_prijs':
          return formatCurrency(resultCarPrice, step?.priceUnit);
        default:
          return '';
      }
    }

    return '';
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <h3 className={styles.card_title}>{step?.title}</h3>
        <p className={styles.card_text}>{step?.text}</p>
        <ul className={styles.card_list}>
          {step?.items?.map((item) => {
            const itemValue = getItemValue(item);
            if (!itemValue) return null;
            return (
              <li className={styles.card_list_item} key={item.id}>
                <p className={styles.card_list_item_text}>{item?.text}</p>
                <p className={styles.card_list_item_value}>{itemValue}</p>
              </li>
            );
          })}
          <li className={styles.card_list_item}>
            <p>{step?.summaryLastLabel || 'Want to buy this configuration?'}</p>
            <p>
              <a
                // step?.summaryLastButtonUrl
                href={`${carTypeItemSelected?.carPdpUrl?.href || ''}?carModel=${encodeURIComponent(
                  getCarModelParam()
                )}&carColor=${encodeURIComponent(
                  carColor?.colorName || ''
                )}&carVersion=${encodeURIComponent(carVersionItemSelected?.title || '')}${
                  carTypeItemSelected?.carPdpUrl?.querystring || ''
                }`}
              >
                {step?.summaryLastButtonText || 'Enquire'}
              </a>
            </p>
          </li>
        </ul>
        <div className={styles.card_buttons}>
          <button className={styles.card_buttons_buttonBack} onClick={() => onClickStep(index - 1)}>
            <Chevron color="rgba(18, 18, 18, 1)" isRotated />
          </button>
          <div className={styles.card_buttons_buttonWrapper}>
            <Button
              className={styles.card_buttons_buttonWrapper_button}
              onClick={handleGoToCalculator}
              isShowTooltip={false}
            >
              {step?.buttonText || 'Finance your car'}
              <Chevron />
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.image}>
        <Image field={carColor?.image} />
      </div>
    </div>
  );
}
